exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".exp-summary .info{max-width:600px}.exp-summary .exp-icon{width:90px;height:90px}.exp-summary .exp-link{text-decoration:none;color:#fff;transition:background .2s ease-in-out}.exp-summary .exp-link:hover{background-color:#000;transition-timing-function:ease-out}", ""]);

